import { Box, Button, Card, Flex, Heading, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useSimpleResumeManager } from '../simple-resume-manager.provider';

const SimpleResumeManagerFiltersView = () => {
   const simpleResumeManager = useSimpleResumeManager();

   return (
      <Card m="3" className="simple-resume-manager-filters">
         <Flex direction="column" gap="2" width="100%">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>

            <Flex gap="3" align="end" wrap="wrap">
               <Box minWidth="300px" width="100%" maxWidth="420px">
                  <TextField.Root
                     placeholder="Search by Resume ID or Resume Name"
                     size="3"
                     color="blue"
                     autoComplete="off"
                     value={simpleResumeManager.searchStr}
                     onChange={(e) => {
                        simpleResumeManager.onSearchChange(e.target.value);
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                           simpleResumeManager.submitSearch();
                        }
                     }}
                  />
               </Box>

               <Button
                  size="3"
                  onClick={() => {
                     simpleResumeManager.submitSearch();
                  }}
               >
                  Search
               </Button>
            </Flex>
         </Flex>
      </Card>
   );
};

export const SimpleResumeManagerFilters = observer(SimpleResumeManagerFiltersView);
